import { render, staticRenderFns } from "./BillingAdminInvoiceSales.vue?vue&type=template&id=588fef15&scoped=true&"
import script from "./BillingAdminInvoiceSales.vue?vue&type=script&lang=js&"
export * from "./BillingAdminInvoiceSales.vue?vue&type=script&lang=js&"
import style0 from "./BillingAdminInvoiceSales.vue?vue&type=style&index=0&id=588fef15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588fef15",
  null
  
)

export default component.exports